import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=607b166d&scoped=true"
import script from "./goodsDialog.vue?vue&type=script&lang=js"
export * from "./goodsDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=607b166d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b166d",
  null
  
)

export default component.exports